module.exports = __webpack_public_path__ + "static/img/User-Admin.06e38a67.png";